export const setItem = (name, value) => {
  if (typeof localStorage !== 'object') {
    return;
  }
  return window.localStorage.setItem(name, JSON.stringify(value));
};

export const getItem = name => {
  if (typeof localStorage !== 'object') {
    return;
  }
  let value = window.localStorage.getItem(name);
  return value ? JSON.parse(value) : {};
};
